import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';

const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private permissionSubject = new BehaviorSubject<any[]>([]);
  permissions$ = this.permissionSubject.asObservable();

  private decodedToken: any = null;

  constructor() {
    this.loadToken();
  }

  /** Reads and normalizes token from localStorage */
  public getToken(): string {
    const stored = localStorage.getItem('user');
    if (!stored) return "";

    let token = "";

    // CASE 1: Stored as JSON { token: "..." }
    try {
      const obj = JSON.parse(stored);
      token = obj.token || stored;
    } catch {
      // CASE 2: Stored as raw string
      token = stored;
    }

    // CASE 3: Clean Python b'...'
    token = token.replace(/^b'|'+$/g, '');

    return token;
  }

  /** Load token and permissions once */
public loadToken() {
  const token = this.getToken();
  if (!token) return;

  try {
    this.decodedToken = helper.decodeToken(token);
    this.permissionSubject.next(this.decodedToken?.permission || []);
  } catch (err) {
    console.error("Token decode failed:", err);
  }
}
getDecodedToken() {
  return this.decodedToken;
}
  /** Public getter for permissions */
  public getLoggedUserPermissions(): any[] {
    return this.permissionSubject.value;
  }

  public getLoggedUserRole(): any {
    return this.decodedToken?.role_id;
  }

  public isAuthenticated(): boolean {
    return !!this.getToken();
  }

  public getLoggedUserInfo(): any {
    return this.decodedToken;
  }

  public getResetLoginId(token: string): any {
    return helper.decodeToken(token);
  }
}
